const PropTypes = require('prop-types');
const React = require('react');
const PackageInput = require('components/shipping_labels/package_input');

function PackageInputs(props) {
  return (
    <div>
      <div className="g-container">
        <PackageInput
          fieldName="length_inches"
          defaultValue={props.package.lengthInches}
          titleKey="length"
          measurementUnitText="in"
        />
        <PackageInput
          fieldName="width_inches"
          defaultValue={props.package.widthInches}
          titleKey="width"
          measurementUnitText="in"
        />
        <PackageInput
          fieldName="height_inches"
          defaultValue={props.package.heightInches}
          titleKey="height"
          measurementUnitText="in"
        />
        <PackageInput
          fieldName="pounds"
          defaultValue={props.package.weightPounds}
          titleKey="weightTitle"
          subtitleKey="weightSubTitle"
          measurementUnitText="lbs"
        />
      </div>
      <p className="small muted mb-0">
        {I18n.t('js.dashboard.selling.shippingLabels.package.inaccurateDimensionsWarning')}
        <br />
        <a
          className="small"
          href="http://www.ups.com/avoidcharges"
          target="_blank"
          rel="noopener noreferrer"
          tabIndex="-1"
        >
          {I18n.t('js.dashboard.selling.shippingLabels.package.tipsToAvoidCorrections')}
        </a>
      </p>
    </div>
  );
}

PackageInputs.propTypes = {
  package: PropTypes.object.isRequired,
};

module.exports = PackageInputs;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/package_inputs.jsx